<template>
  <div :id="`plotlyContainer${uuid}`" v-if="show"></div>
</template>

<script>
import Vue from 'vue'
import Plotly from 'plotly.js/lib/core';
Plotly.register([
    require('plotly.js/lib/violin'),
    require('plotly.js/lib/groupby'),
    require('plotly.js/lib/locales/zh-cn'),
]);

import {DefaultTheme} from '@/utils/chart'
Vue.use(Plotly)

export default {
    props:{
        conf: {type:Object, default:{}},
        fields: {type:Array, default:{}},
        datas: {type:Array, default:()=>[]},
        height: {type:Number, default:500},
        uuid: {type:String, default:''},
    },
    mounted() {
        this.chart()
    },
    watch: {
      datas() {
        this.show = false
        this.$nextTick(()=>{
          this.show = true
          this.$nextTick(()=>{
            this.chart()
          })
        })
      }
    },
    data() {
      return {
        show: true,
      }
    },
    methods: {
      chart() {
            const colors = DefaultTheme.colors_24
            let styles = []
            // 根据x轴指定颜色
            let allxs = _.map(this.datas, this.conf.x.id)
            let allys = _.map(this.datas, this.conf.y.id)
            let xs = _.uniq(allxs)
            xs.forEach((x, index)=>{
              styles.push({
                target:x, 
                value:{
                  line:{
                    color:colors[index%colors.length],
                  }
                }
              })
            })

            var data = [{
                type: 'violin',
                x: allxs,
                y: allys,
                points: 'none',
                box: {
                    visible: true,
                    fillcolor:'#fff',
                    width:0.1,
                },
                line: {
                    color: 'black',
                },
                opacity:0.6,
                hoverlabel: {
                    bgcolor:'#fff',
                    bordercolor:'#eee',
                    font: {
                        color:'#000',
                        size:12,
                    }
                },
                spanmode:'hard',
                meanline: {
                    visible: true,
                    color:'#b10000',
                    width: 3,
                },
                transforms: [{
                    type: 'groupby',
                    groups: allxs,
                    styles: styles
                }],
            }]

            var layout = {
                margin: {
                    pad:10,
                    t:0,
                },
                yaxis: {
                    title: {
                        text: this.conf.y.title,
                        standoff: 10,
                        font: {
                            size:12,
                        }
                    },
                    zeroline: true,
                    zerolinecolor: '#ddd',
                    rangemode:'tozero',
                },
                height:this.height,
            }
            var config = {locale: 'zh-cn'}
            Plotly.plot(`plotlyContainer${this.uuid}`, data, layout, config);
        }
    }
}
</script>
<style>
.modebar-container{
    display: none;
}
</style>